/**
 * Logo portálu Hearth & Table — okrúhly emblém (lampa, kocka, dubové lístie)
 * z `public/brand/`. Hry majú vlastné logá (Unmatched: skrížené meče), portál
 * je spoločná strecha nad nimi. V hre (`compact`) len malý emblém ako cesta späť.
 */

export function PortalLogo({ compact = false }: { compact?: boolean }) {
  return (
    <span className={`logo logo--portal${compact ? ' logo--compact' : ''}`}>
      <img className="logo__emblem" src="/brand/hearth-table-160.webp" alt="" width={40} height={40} draggable={false} />
      <span className="logo__text">
        <span className="logo__name">Hearth &amp; Table</span>
        <span className="logo__tag">Herňa pre partiu</span>
      </span>
    </span>
  );
}
